module.exports = __webpack_public_path__ + "static/media/App_Store_Badge.83178b2d.svg";